import { render, staticRenderFns } from "./cadastro-fornecedores.vue?vue&type=template&id=7edde186&scoped=true"
import script from "./cadastro-fornecedores.vue?vue&type=script&lang=js"
export * from "./cadastro-fornecedores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edde186",
  null
  
)

export default component.exports